import { EventEmitter } from 'events'

class Scheduler extends EventEmitter
  constructor: (audioContext, { bpm }) ->
    super()
    @audioContext = audioContext
    @secondsPerBeat = @getSecondsPerBeat(bpm)

    @lookahead = 25.0
    @scheduleAheadTime = 0.1
    @nextStepTime = @audioContext.currentTime

    @scheduler()

  getSecondsPerBeat: (bpm) ->
    60 / bpm

  setBPM: (bpm) ->
    @secondsPerBeat = @getSecondsPerBeat(bpm)

  nextStep: ->
    @nextStepTime += @secondsPerBeat

  scheduleStep: (time) ->
    @emit('tick', time, @secondsPerBeat)

  scheduler: ->
    while @nextStepTime < @audioContext.currentTime + @scheduleAheadTime
      @scheduleStep(@nextStepTime)
      @nextStep()

    @timer = setTimeout(=>
      @scheduler()
    , @lookahead)

export default Scheduler
